import { PrinterOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, thematicColors } from '@revenuemarket/design';
import { Modal, ModalProps, Typography } from 'antd';
import Image from 'next/image';

interface DescriptionProps {
  icon: React.ReactNode;
  description: string;
}

const Description: React.FC<DescriptionProps> = ({ ...props }) => {
  return (
    <Flex
      gap={8}
      style={{
        padding: 8,
        borderBottom: `1px solid ${colorTokens.borderDefault}`,
      }}
    >
      {props.icon}
      <Typography.Text>{props.description}</Typography.Text>
    </Flex>
  );
};

interface Props extends ModalProps {}

const ConnectBaroBillModal: React.FC<Props> = ({ ...props }) => {
  return (
    <Modal open={props.open} onCancel={props.onCancel} closable okText="계속" onOk={props.onOk}>
      <Flex
        gap={24}
        style={{
          padding: '8px 24px 12px 24px',
        }}
        justify="center"
        align="center"
        direction="column"
      >
        <Flex align="center">
          <Image
            alt="barobill-icon"
            src="https://static.clobe.ai/image/clobe-logo-dark-icon.png"
            width={24}
            height={24}
            style={{
              height: 24,
            }}
          />
          <span style={{ color: colorTokens.textDescription }}>..........</span>
          <Image
            alt="barobill-icon"
            src="https://static.clobe.ai/image/barobill-icon.png"
            width={28}
            height={28}
            style={{
              height: 28,
            }}
          />
        </Flex>
        <Flex direction="column" gap={4} align="center">
          <Typography.Title level={5}>세금계산서 발급을 위해 바로빌에 연동합니다</Typography.Title>
          <Typography.Text
            style={{
              color: thematicColors.primary.medium,
            }}
          >
            클로브를 통한 발급 비용은 <b>무료</b>입니다
          </Typography.Text>
        </Flex>
        <Flex direction="column">
          <Description
            icon={<ShareAltOutlined />}
            description="우리 회사와 거래처의 사업자 정보를 수신합니다"
          />
          <Description
            icon={<PrinterOutlined />}
            description="우리 회사 계정으로 전자세금계산서를 발급합니다"
          />
        </Flex>
        <Flex direction="column" gap={4} align="center">
          <Typography.Text>
            바로빌은 국세청에 등록된 전자세금계산서 시스템 사업자입니다
          </Typography.Text>
          <Typography.Text>
            계속 버튼을 클릭하면{' '}
            <b
              onClick={() => {
                window.open('https://www.barobill.co.kr/join/barobill_rule.asp', '_blank');
              }}
            >
              바로빌 이용약관
            </b>
            에 동의한 것으로 간주됩니다
          </Typography.Text>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConnectBaroBillModal;
